import logo from "./logo.svg";
import "./App.css";
import { Route, Switch, Redirect } from "react-router-dom";
import Movie from "./components/Movies";
import Book from "./components/bookMovie";

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/movies/:region" component={Movie}></Route>
        <Route path="/movies" component={Movie}></Route>
        <Route path="/bookMovie/:region/:id/buyTicket" component={Book}></Route>
        <Route path="/bookMovie" component={Book}></Route>
        <Redirect to="/movies/NCR"></Redirect>
      </Switch>
    </div>
  );
}

export default App;
